export default __webpack_public_path__ + "static/media/arrow.f07ce2e1.svg";